import styled from "styled-components"

interface IButtonProps {
  children: React.ReactNode
  disabled?: boolean
}

const StyledButton = styled.button`
  background-color: ${(props) => props.theme.colors.primary};
  ${(props) =>
    props.disabled && `opacity: 0.5; cursor: default; pointer-events: none;`}
  text-align: center;
  width: 100%;
  color: ${(props) => props.theme.colors.buttonText};
  font-family: inherit;
  font-size: 0.8rem;
  font-size: clamp(0.8rem, 0.76rem + 0.2vw, 1rem);
  font-weight: 700;
  margin-block-start: clamp(1rem, 0.8rem + 1vw, 2rem);
  padding: 1rem;
  /* reset styles */
  border: none;

  &:hover {
    cursor: pointer;
  }
`

const Button = (props: IButtonProps) => {
  const { children, disabled } = props

  return <StyledButton disabled={disabled}>{children}</StyledButton>
}

export { Button }
